import { i18n, pr, React, ui } from "aaa";
import { MessageScreen } from "components/common/MessageScreen";
import { inject } from "mobx-react";
import authStore from "stores/AuthStore";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { SIdentitySettingsStore } from "./SIdentitySettingsStore";

const link = authStore.locale === "de"
    ? "https://www.sparkasse.at/privatkunden/digitales-banking/inside/s-identity-app"
    : "https://www.sparkasse.at/privatkunden/digitales-banking/inside/s-identity-app-en";

interface IProps {
    store: SIdentitySettingsStore;
    externalInterfaceStore: ExternalInterfaceStore;
}

@i18n.injectIntl
@inject("externalInterfaceStore")
export class SIdentitySettingsAddAdditionalDesktopInfo extends React.Component<IProps & i18n.InjectedIntlProps, {}> {
    render() {
        return (
            <MessageScreen
                icon={pr.IconInfoCircleHollow}
                iconStyle={{ color: "white" }}
                messageComponent={
                    <div className="theme-success-screen-link-wrapper">
                        <i18n.FormattedHTMLMessage
                            id="sidentitySettings.additionalDesktop.info.message"
                            values={{
                                href: externalInterfaceStore.isGeorgeApp ? `georgeapp://at/open_external_link?url=${encodeURIComponent(link)}` : link,
                                target: "_blank"
                            }}
                        />
                    </div>
                }
                buttonLabelId="common.backToGeorgeGo"
                onDismiss={() => this.props.externalInterfaceStore.raiseExitSuccess()}
            />
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/loginManagement/sIdentitySettings/SIdentitySettingsAddAdditionalDesktopInfo.tsx